export const GET_MANAGE_EXTENSION_REQUEST = "GET_MANAGE_EXTENSION_REQUEST";
export const GET_MANAGE_EXTENSION_SUCCESS = "GET_MANAGE_EXTENSION_SUCCESS";
export const GET_MANAGE_EXTENSION_FAIL = "GET_MANAGE_EXTENSION_FAIL";

export const GET_MANAGE_PROFILE_EXTENSION_REQUEST = "GET_MANAGE_PROFILE_EXTENSION_REQUEST";
export const GET_MANAGE_PROFILE_EXTENSION_SUCCESS = "GET_MANAGE_PROFILE_EXTENSION_SUCCESS";
export const GET_MANAGE_PROFILE_EXTENSION_FAIL = "GET_MANAGE_PROFILE_EXTENSION_FAIL";

export const CREATE_MANAGE_EXTENSION_REQUEST = "CREATE_MANAGE_EXTENSION_REQUEST";
export const CREATE_MANAGE_EXTENSION_SUCCESS = "CREATE_MANAGE_EXTENSION_SUCCESS";
export const CREATE_MANAGE_EXTENSION_FAIL = "CREATE_MANAGE_EXTENSION_FAIL";

export const UPDATE_MANAGE_EXTENSION_REQUEST = "UPDATE_MANAGE_EXTENSION_REQUEST";
export const UPDATE_MANAGE_EXTENSION_SUCCESS = "UPDATE_MANAGE_EXTENSION_SUCCESS";
export const UPDATE_MANAGE_EXTENSION_FAIL = "UPDATE_MANAGE_EXTENSION_FAIL";

export const DELETE_MANAGE_EXTENSION_REQUEST = "DELETE_MANAGE_EXTENSION_REQUEST";
export const DELETE_MANAGE_EXTENSION_SUCCESS = "DELETE_MANAGE_EXTENSION_SUCCESS";
export const DELETE_MANAGE_EXTENSION_FAIL = "DELETE_MANAGE_EXTENSION_FAIL";